module.exports = __webpack_public_path__ + "assets/img/aicb.e03d2689.jpg";